import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'name',
        label: 'name',
        defaultShow: true,
    },
    {
        key: 'count',
        label: 'count',
        type: 'number-filter',
    },
];

export const rowsKeys = [
    'salesRepresentativeCodes',
    'keyAccountManagerCodes',
    'claimReasonCodes',
    'claimStatusCodes',
    'transportStatusCodes',
    'documentTypesCodes',
    'expeditionMethodCodes',
    'handlingUnitsCodes',
    'orderStatusCodes',
    'paymentCodes',
    'productTypeCodes',
    'productRelationCodes',
    'receivingStatusCodes',
    'retunReasonCodes',
    'returnResolutionCodes',
    'returnStatusCodes',
    'serviceCodes',
    'shipperCodes',
    'shipperMessageCodes',
    'claimsResolverCodes',
    'receivingDeliveryTypeCodes',
    'receivingUrgentCodes',
    'receivingPackingTypeCodes',
    'receivingPalletCodes',
    'receivingTypeCodes',
    'productInsetTypeCodes',
    'emailTemplateTypeCodes',
    'orderPriorityCodes',
    'productCompletionSheetStatusCodes',
    'stockTakingStatusCodes',
    'stockTakingTypeCodes',
    'jobStatusCodes',
    'jobUnitCodes',
    'jobCategoryCodes',
    'driverCompanyCodes',
    'jobDepartmentCodes',
    'jobShipperCodes',
    'carrierExtraFeeTypeCodes',
    'providerSystemCodes',
    'sourceSysCodes',
    'transportPaidByCodes',
];
